import { inject, Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { CmsService } from '../cms/cms.service'
import { Translations } from './translations.type'

@Injectable()
export class TranslationsLoaderService {
  get translations(): Translations {
    if (!this._translations) {
      throw new Error('translations not yet loaded')
    }
    return this._translations
  }

  private _translations: Translations | null = null
  private readonly cms = inject(CmsService)

  readonly load = async (): Promise<void> => {
    this._translations = await firstValueFrom(this.cms.translations())
  }
}
